import { render, staticRenderFns } from "./my-account-menu.vue?vue&type=template&id=3294c88c&scoped=true&"
import script from "./my-account-menu.vue?vue&type=script&lang=js&"
export * from "./my-account-menu.vue?vue&type=script&lang=js&"
import style0 from "./my-account-menu.vue?vue&type=style&index=0&id=3294c88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294c88c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemTitle})
